/* /deck-view and /precons?deck= — the browser half of a deck page.
 * The server already rendered the list, stats, notes and related decks (pages/deck-view.php,
 * pages/precons.php) and embedded the deck as #deck-data. Here: card sheets (rules text from Scryfall on
 * open), hover previews, the visual view, the sample hand, copy / share / buy / analyze / "build one like
 * this". Community decks add view counting, likes (the Firebase SDK loads only for signed-in visitors)
 * and the owner's edit link; precons ("kind": "precon") add a price fallback when the server had none.
 */
import "../lib/site.js";
import "../lib/cards.js";
import "../lib/cardsheet.js";
import "../lib/fb-lazy.js";

(function () {
  "use strict";

  var KD = window.KD, D = KD.data, esc = KD.esc;
  var el = document.getElementById("deck-data");
  if (!el) return;
  var data;
  try { data = JSON.parse(el.textContent); } catch (e) { return; }
  var cards = data.cards || [];
  var isPrecon = data.kind === "precon", EV = isPrecon ? "precon_" : "deck_";
  var FN = "https://us-central1-krakenthemeta.cloudfunctions.net/";
  var ORDER = ["Commander", "Creatures", "Planeswalkers", "Instants", "Sorceries", "Artifacts", "Enchantments", "Battles", "Lands", "Other"];
  var isCmdFormat = D.isCommanderFormat(data.format);

  function front(s) { return String(s || "").split("//")[0]; }
  function groupOf(c) {
    if (c.cmd) return "Commander";
    var t = front(c.t).toLowerCase();
    var map = [["creature", "Creatures"], ["planeswalker", "Planeswalkers"], ["instant", "Instants"], ["sorcery", "Sorceries"], ["battle", "Battles"], ["land", "Lands"], ["artifact", "Artifacts"], ["enchantment", "Enchantments"]];
    for (var i = 0; i < map.length; i++) if (t.indexOf(map[i][0]) !== -1) return map[i][1];
    return "Other";
  }
  function listText() {
    var g = {};
    cards.forEach(function (c) { (g[groupOf(c)] = g[groupOf(c)] || []).push(c); });
    var body = function (k) { return g[k].sort(function (a, b) { return a.n.localeCompare(b.n); }).map(function (c) { return c.q + " " + c.n; }).join("\n"); };
    // 2026-10-03: a "Commander" section, so the copy knows who leads it (imports used to drop it)
    var rest = ORDER.filter(function (k) { return k !== "Commander" && g[k]; }).map(body).join("\n");
    return g.Commander ? "Commander\n" + body("Commander") + "\n\nDeck\n" + rest : rest;
  }
  var canonical = (KD.$('link[rel="canonical"]') || {}).href || location.href;

  // ---------------------------------------------------------------- card sheet
  function openCard(i) {
    var c = cards[i];
    if (!c) return;
    KD.cardx.openLazy({ id: c.id, name: c.n, imageUrl: c.img, manaCost: c.mc, types: c.t, price: c.p == null ? "N/A" : String(c.p) }, {
      note: '<p class="hint">' + c.q + (c.q === 1 ? " copy" : " copies") + " in this deck</p>",
      actions: '<a class="btn btn--ghost btn--sm" href="/cards-pricing?q=' + encodeURIComponent('!"' + front(c.n).trim() + '"') + '&prints=1">' + KD.icon("search") + "<span>All printings &amp; prices</span></a>"
    });
    KD.ga(EV + "card_open", { card: c.n });
  }

  // ---------------------------------------------------------------- decklist: rows, visual view, hover preview
  var groupsBox = KD.$("[data-groups]");
  function render(view) {
    if (!groupsBox) return;
    if (view !== "cards") { groupsBox.classList.remove("is-visual"); groupsBox.innerHTML = listHTML; return; }
    var g = {};
    cards.forEach(function (c, i) { (g[groupOf(c)] = g[groupOf(c)] || []).push(i); });
    groupsBox.classList.add("is-visual");
    groupsBox.innerHTML = ORDER.filter(function (k) { return g[k]; }).map(function (k) {
      var ids = g[k].sort(function (a, b) { return cards[a].n.localeCompare(cards[b].n); });
      var n = ids.reduce(function (s, i) { return s + cards[i].q; }, 0);
      return '<section class="dgroup"><h3>' + (k === "Commander" && ids.length > 1 ? "Commanders" : k) + " <span>" + n + '</span></h3><div class="dcards">' +
        ids.map(function (i) {
          var c = cards[i], img = KD.safeUrl(c.img);
          return '<button type="button" data-card="' + i + '" aria-label="' + esc(c.q + " " + c.n) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '<span class="noimg">' + esc(c.n) + "</span>") +
            (c.q > 1 ? '<span class="qty">' + c.q + "×</span>" : "") + "</button>";
        }).join("") + "</div></section>";
    }).join("");
  }
  var listHTML = groupsBox ? groupsBox.innerHTML : "";
  var view = "list";
  try { view = localStorage.getItem("kd_deck_view") === "cards" ? "cards" : "list"; } catch (e) { /* ignore */ }
  if (view === "cards") render("cards");
  KD.$$("[data-view]").forEach(function (b) {
    b.setAttribute("aria-selected", String(b.getAttribute("data-view") === view));
    b.addEventListener("click", function () {
      view = b.getAttribute("data-view");
      try { localStorage.setItem("kd_deck_view", view); } catch (e) { /* ignore */ }
      KD.$$("[data-view]").forEach(function (x) { x.setAttribute("aria-selected", String(x === b)); });
      render(view);
    });
  });
  document.addEventListener("click", function (e) {
    var row = e.target.closest("[data-card]");
    if (row && row.closest("[data-decklist], [data-hand], [data-cardzone]")) { unpeek(); openCard(+row.getAttribute("data-card")); }
  });

  var fine = window.matchMedia("(hover: hover) and (pointer: fine)"), pop = null, peekRow = null;
  function unpeek() { peekRow = null; if (pop) pop.classList.remove("is-on"); }
  document.addEventListener("mouseover", function (e) {
    if (!fine.matches) return;
    var row = e.target.closest(".drow[data-card]");
    if (!row || row === peekRow) return;
    var c = cards[+row.getAttribute("data-card")], url = c && KD.safeUrl(c.img);
    if (!url) return;
    peekRow = row;
    if (!pop) { pop = document.createElement("div"); pop.className = "cpop"; pop.setAttribute("aria-hidden", "true"); pop.innerHTML = '<img alt="">'; document.body.appendChild(pop); }
    pop.firstChild.src = url;
    var r = row.getBoundingClientRect(), w = 236, h = Math.round(w * 680 / 488);
    var left = e.clientX + 28;
    if (left + w > window.innerWidth - 10) left = e.clientX - w - 28;
    pop.style.left = Math.max(10, left) + "px";
    pop.style.top = Math.max(10, Math.min(window.innerHeight - h - 10, r.top + r.height / 2 - h / 2)) + "px";
    pop.classList.add("is-on");
  });
  document.addEventListener("mouseout", function (e) { var row = e.target.closest(".drow[data-card]"); if (row && !row.contains(e.relatedTarget)) unpeek(); });
  window.addEventListener("scroll", unpeek, { passive: true });

  // ---------------------------------------------------------------- sample hand
  var handBox = KD.$("[data-hand-cards]"), handNote = KD.$("[data-hand-note]");
  var library = [], pos = 0, hand = [];
  cards.forEach(function (c, i) { if (c.cmd && isCmdFormat) return; for (var k = 0; k < c.q; k++) library.push(i); });
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  function paintHand() {
    var lands = hand.filter(function (i) { var t = front(cards[i].t).toLowerCase(); return t.indexOf("land") !== -1 && t.indexOf("creature") === -1; }).length;
    handBox.innerHTML = hand.map(function (i) {
      var c = cards[i], img = KD.safeUrl(c.img);
      return '<button type="button" class="hand__card" data-card="' + i + '" aria-label="' + esc(c.n) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="noimg">' + esc(c.n) + "</span>") + "</button>";
    }).join("");
    handNote.textContent = hand.length ? lands + (lands === 1 ? " land" : " lands") + " · " + (hand.length - lands) + (hand.length - lands === 1 ? " spell" : " spells") : "";
  }
  function newHand() { if (!library.length) return; shuffle(library); hand = library.slice(0, 7); pos = 7; paintHand(); KD.ga(EV + "hand", { deck: data.id }); }
  if (handBox) {
    KD.$("[data-hand-new]").addEventListener("click", newHand);
    KD.$("[data-hand-draw]").addEventListener("click", function () {
      if (!hand.length) { newHand(); return; }
      if (pos >= library.length) { KD.toast("Your library is empty.", "info"); return; }
      hand.push(library[pos++]);
      paintHand();
    });
    if (library.length >= 7) newHand();
  }

  // ---------------------------------------------------------------- views (the incrementDeckViews callable, once per visit)
  if (!isPrecon) (function () {
    var key = "kd_viewed_" + data.id;
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, "1"); } catch (e) { /* count anyway */ }
    fetch(FN + "incrementDeckViews", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ data: { deckId: data.id } }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var n = j && j.result && j.result.newViewCount;
        var b = KD.$("[data-views] b");
        if (n && b) b.textContent = KD.fmt(n);
      }).catch(function () { /* the count just doesn't move */ });
  })();

  // ---------------------------------------------------------------- likes
  var likeBtn = KD.$("[data-like]"), heartsEl = KD.$("[data-hearts]");
  var hearts = data.hearts || 0, liked = false, likeBusy = false;
  function paintLike() {
    likeBtn.setAttribute("aria-pressed", String(liked));
    likeBtn.classList.toggle("is-on", liked);
    heartsEl.textContent = KD.fmt(hearts);
  }
  function askSignIn(what) {
    KD.sheet({
      title: "Sign in to " + what,
      body: '<p class="hint" style="font-size:15px">A free KrakenTheMeta account lets you like decks, copy them into your own deck list and build new ones with AI.</p>',
      foot: '<button class="btn btn--ghost" type="button" data-close>Not now</button><a class="btn btn--lure" href="https://krakenthemeta.com/sign-in">Sign in or create an account</a>'
    });
  }
  async function heartDocs(db, uid) {
    return db.collection("hearts").where("userId", "==", uid).where("deckId", "==", data.id).get();
  }
  async function toggleLike() {
    if (!KD.signedIn) { askSignIn("like decks"); return; }
    if (likeBusy) return;
    likeBusy = true;
    likeBtn.classList.add("is-busy");
    try {
      await KD.firebase.load(["database"]);
      var user = await KD.firebase.user();
      if (!user) { askSignIn("like decks"); return; }
      var db = firebase.firestore();
      var deckRef = db.collection("publicDecks").doc(data.id);
      var existing = await heartDocs(db, user.uid);
      var wasLiked = !existing.empty, count = 0;
      await db.runTransaction(async function (tx) {
        var snap = await tx.get(deckRef);
        var cur = Math.max(0, Number((snap.data() || {}).hearts) || 0);
        count = wasLiked ? Math.max(0, cur - 1) : cur + 1;
        tx.update(deckRef, { hearts: count });
        if (wasLiked) existing.docs.forEach(function (d) { tx.delete(d.ref); });
        else tx.set(db.collection("hearts").doc(user.uid + "_" + data.id), { userId: user.uid, deckId: data.id });
      });
      liked = !wasLiked;
      hearts = count;
      paintLike();
      KD.ga(liked ? "deck_like" : "deck_unlike", { deck: data.id });
      // tell the publisher (only on a like, only after it saved, never for your own deck)
      if (liked && data.publisher && data.publisher !== user.uid) {
        var me = await db.collection("users").doc(user.uid).get().catch(function () { return null; });
        var who = (me && me.exists && (me.data() || {}).name) || user.displayName || "Someone";
        firebase.database().ref("notifications").child(data.publisher).push({ message: who + " liked '" + data.name + "'", taggerId: user.uid, taggerName: who, timestamp: Date.now(), viewed: false }).catch(function () {});
      }
    } catch (e) {
      console.error("like", e);
      KD.toast("Couldn't save that like. Try again.", "err");
    } finally {
      likeBusy = false;
      likeBtn.classList.remove("is-busy");
    }
  }
  if (likeBtn) likeBtn.addEventListener("click", toggleLike);

  // signed in: show the liked state and, for the publisher, a link back to the builder
  if (KD.signedIn && likeBtn) {
    (window.requestIdleCallback || function (fn) { setTimeout(fn, 1500); })(function () {
      KD.firebase.load().then(KD.firebase.user).then(function (user) {
        if (!user) return;
        var db = firebase.firestore();
        heartDocs(db, user.uid).then(function (snap) { liked = !snap.empty; paintLike(); }).catch(function () {});
        if (data.publisher && user.uid === data.publisher) {
          var edit = KD.$("[data-owner-edit]");
          db.collection("users").doc(user.uid).collection("publishedDecks").where("publicDeckId", "==", data.id).limit(1).get()
            .then(function (s) { if (!s.empty) edit.href = "/dashboard#/deck/" + encodeURIComponent(s.docs[0].id); })
            .catch(function () {})
            .then(function () { edit.hidden = false; });
        }
      }).catch(function () { /* likes still work on click */ });
    });
  }

  // ---------------------------------------------------------------- copy / share / more
  var copyBtn = KD.$("[data-copy-deck]");
  if (copyBtn) copyBtn.addEventListener("click", function () {
    try {
      localStorage.setItem("ktm_pending_import", JSON.stringify({ name: data.name, format: data.format || "commander", list: listText(), at: Date.now(), from: isPrecon ? "precons" : "deck-view", deckId: data.id }));
    } catch (e) { KD.toast("Your browser blocked storage, so use Copy decklist and paste it into the dashboard.", "err"); return; }
    KD.ga(EV + "copy_to_mine", { deck: data.id, signed_in: KD.signedIn });
    location.href = KD.signedIn ? "/dashboard" : "https://krakenthemeta.com/sign-in";
  });

  function share() {
    var title = data.name + (data.commander ? " — " + data.commander : "");
    KD.ga(EV + "share", { deck: data.id });
    if (navigator.share && KD.mobile()) { navigator.share({ title: title, text: title + (isPrecon ? " — Commander precon decklist on KrakenTheMeta" : " — a deck on KrakenTheMeta"), url: canonical }).catch(function () {}); return; }
    KD.copy(canonical, "Link copied.");
  }
  var shareBtn = KD.$("[data-share]");
  if (shareBtn) shareBtn.addEventListener("click", share);

  function analyze() {
    try { localStorage.setItem("kraken_pending_analysis", listText()); } catch (e) { /* it opens empty */ }
    location.href = "/mtg-deck-analyzer";
  }
  var an = KD.$("[data-analyze]");
  if (an) an.addEventListener("click", function (e) { e.preventDefault(); analyze(); });

  var moreBtn = KD.$("[data-more]");
  if (moreBtn) moreBtn.addEventListener("click", function () {
    var file = (data.name || "deck").replace(/[^a-z0-9]+/gi, "_").replace(/^_|_$/g, "").toLowerCase() || "deck";
    KD.menu(moreBtn, [
      { label: "Copy decklist", icon: "copy", onClick: function () { KD.copy(listText(), "Decklist copied."); KD.ga(EV + "copy_list", { deck: data.id }); } },
      { label: "Download as .txt", icon: "download", onClick: function () { KD.download(file + ".txt", listText() + "\n"); KD.ga(EV + "download", { deck: data.id }); } },
      { label: "Share on X", icon: "x-logo", href: "https://twitter.com/intent/tweet?text=" + encodeURIComponent("Check out " + data.name + " on @krakenthemeta\n" + canonical), external: true },
      { label: "Copy link", icon: "link", onClick: function () { KD.copy(canonical, "Link copied."); } },
      "sep",
      { label: "Analyze this deck", icon: "chart", onClick: analyze }
    ], data.name);
  });

  var likeThis = KD.$("[data-build-like]");
  if (likeThis) likeThis.addEventListener("click", function (e) {
    // 2026-10-03: a precon's "Upgrade it with AI" upgrades THE PRECON — its list goes to the
    // dashboard and opens in "Improve this deck" (it used to start an unrelated new build)
    if (isPrecon) {
      try {
        localStorage.setItem("ktm_pending_upgrade", JSON.stringify({ name: data.name + " (upgraded)", format: data.format || "commander", list: listText(),
          goal: "Upgrade this precon: keep its commander and theme, cut the weakest cards and add stronger ones in the same colors.", goals: ["weak"], at: Date.now(), from: "precons" }));
      } catch (err) { KD.toast("Your browser blocked storage, so use Copy decklist and paste it into the dashboard.", "err"); e.preventDefault(); return; }
      this.href = KD.buildUrl();
      KD.ga(EV + "upgrade_precon", { deck: data.id });
      return;
    }
    KD.stashPrompt(likeThis.getAttribute("data-prompt") || "A deck like “" + data.name + "”" + (data.commander ? ", built around " + data.commander : "") + ".", data.format || "commander");
    this.href = KD.buildUrl();
    KD.ga(EV + "build_like", { deck: data.id });
  });
  var buy = KD.$("[data-buy-deck]");
  if (buy) buy.addEventListener("click", function () { KD.ga(EV + "buy", { deck: data.id, transport_type: "beacon" }); });

  // ---------------------------------------------------------------- precons: prices from the browser when the server had none
  if (isPrecon && !data.priced) {
    var ids = cards.map(function (c) { return c.id; }).filter(Boolean), batches = [];
    for (var b = 0; b < ids.length; b += 75) batches.push(ids.slice(b, b + 75));
    batches.reduce(function (p, batch, n) {
      return p.then(function (acc) {
        return KD.delay(n ? 120 : 0).then(function () {
          return KD.data.scryfall("https://api.scryfall.com/cards/collection", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ identifiers: batch.map(function (id) { return { id: id }; }) }) });
        }).then(function (r) { if (!r.ok) throw new Error("scryfall " + r.status); return r.json(); })
          .then(function (j) { (j.data || []).forEach(function (sc) { var v = sc.prices && (sc.prices.usd || sc.prices.usd_foil); if (v) acc[sc.id] = Number(v); }); return acc; });
      });
    }, Promise.resolve({})).then(function (price) {
      var total = 0, priced = 0, count = 0, tpl = document.createElement("div");
      tpl.innerHTML = listHTML;
      cards.forEach(function (c, i) {
        count += c.q;
        if (price[c.id] == null) return;
        c.p = Math.round(price[c.id] * 100) / 100;
        total += c.p * c.q;
        priced += c.q;
        [document, tpl].forEach(function (root) {
          KD.$$('.drow[data-card="' + i + '"] .drow__price', root).forEach(function (x) { x.textContent = "$" + c.p.toFixed(2); });
        });
      });
      listHTML = tpl.innerHTML;
      if (priced < count * 0.8) return;
      var t = KD.$("[data-total]");
      if (t) { KD.$("b", t).textContent = "$" + total.toFixed(2); t.hidden = false; }
      var f = KD.$("[data-total-facts]");
      if (f) f.textContent = "$" + Math.round(total);
    }).catch(function () { /* the list just shows no prices */ });
  }
})();
